import type { FC } from 'react';
import { Alert } from '@interstate/components/Alert';
import styled from 'styled-components';

const StyledScenarioLimitAlert = styled(Alert)`
    &&& {
        padding: 12px;
    }
`;

const StyledAlertContent = styled.div`
    && {
        margin-left: 12px;
    }
`;

export const ScenarioLimitAlert: FC = () => (
    <StyledScenarioLimitAlert type="info" data-testid="alt-deal-scenario-limit-alert">
        <StyledAlertContent>
            AI Deal Structure recommendation cannot be selected while two scenarios are active. Please remove one to proceed with AI
            Deal Structure.
        </StyledAlertContent>
    </StyledScenarioLimitAlert>
);
